export enum IdentifierFormat {
  GUID = 'GUID',
  NUMERIC = 'NUMERIC',
  STRING = 'STRING',
  UNDEFINED = 'UNDEFINED',
  UNKNOWN = 'UNKNOWN'
}

const uuidv4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const uuidv5Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-5[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Detects the format of an identifier value, which can be a number, string, or undefined.
 *
 * The function returns one of the following `IdentifierFormat` values:
 * - `GUID`: if the identifier matches a UUID v4 or v5 format
 * - `NUMERIC`: if the identifier is a valid integer
 * - `STRING`: if the identifier is a non-empty string
 * - `UNDEFINED`: if the identifier is `undefined`
 * - `UNKNOWN`: if the identifier does not match any of the above formats
 *
 * @param candidate The identifier value to detect the format of
 * @returns {IdentifierFormat} The detected format of the identifier
 */
export const detectIdFormat = (
  candidate: number | string | undefined
): IdentifierFormat => {
  if (candidate === undefined) {
    return IdentifierFormat.UNDEFINED;
  }
  if (uuidv4Regex.test(`${candidate}`)) {
    return IdentifierFormat.GUID;
  }
  if (uuidv5Regex.test(`${candidate}`)) {
    return IdentifierFormat.GUID;
  }
  if (Number.isInteger(candidate)) {
    return IdentifierFormat.NUMERIC;
  }
  if (parseInt(`${candidate}`) > 0) {
    return IdentifierFormat.NUMERIC;
  }
  if (typeof candidate === 'string') {
    return IdentifierFormat.STRING;
  }

  return IdentifierFormat.UNKNOWN;
};
